// 11.5s "How it works" loop (steps 1 and 2; step 3 is a video) (design handoff: how-it-works-timeline.md).
// Pure frame function so the loop is unit-testable; the component applies the
// result to the DOM from requestAnimationFrame.

export const LOOP_SECONDS = 11.5;
/** A frame where every panel has finished — used for reduced motion. */
export const REST_SECONDS = 10;

export const CONNECTION_COUNT = 4;
const BASE_LIMIT = 250_000;

export type ConnectionState = 0 | 1 | 2;

export interface TimelineFrame {
  panelOpacity: number;
  connections: ConnectionState[];
  limit: number;
  limitBarPercent: number;
  limitNote: "basedOnData" | "grows";
}

const clamp = (x: number) => Math.min(1, Math.max(0, x));
const ease = (x: number) => 1 - (1 - clamp(x)) ** 3;

export function getTimelineFrame(elapsedSeconds: number): TimelineFrame {
  const t = elapsedSeconds % LOOP_SECONDS;

  let panelOpacity = 1;
  if (t < 0.4) panelOpacity = t / 0.4;
  else if (t >= 10.9) panelOpacity = (LOOP_SECONDS - t) / 0.6;

  const connections = Array.from({ length: CONNECTION_COUNT }, (_, i) => {
    const start = 0.5 + i * 0.55;
    const done = start + 0.7;
    if (t < start) return 0;
    if (t < done) return 1;
    return 2;
  }) as ConnectionState[];

  let limit = 0;
  if (t >= 5) limit = BASE_LIMIT + Math.min(t - 5, 3) * 5200;
  else if (t >= 3) limit = BASE_LIMIT * ease((t - 3) / 2);
  limit = Math.round(limit / 100) * 100;

  return {
    panelOpacity,
    connections,
    limit,
    limitBarPercent: Math.min(100, (limit / 300_000) * 100),
    limitNote: t < 5.4 ? "basedOnData" : "grows",
  };
}
